import React from 'react';

interface Props {
  onClick?: () => void;
  isExpanded: boolean;
}

export const ButtonLessMore = ({ onClick, isExpanded }: Props) => {
  return (
    <button
      onClick={onClick}
      className="w-full mx-auto mt-2 text-[var(--primary-color)] flex items-center justify-center gap-2 py-1"
    >
      {isExpanded ? (
        <>
          Thu gọn <Icon className="rotate-180" />{' '}
        </>
      ) : (
        <>
          Xem tất cả <Icon />{' '}
        </>
      )}
    </button>
  );
};

const Icon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="8" height="11" viewBox="0 0 8 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.666748 1.5L4.00008 4.83333L7.33341 1.5M0.666748 6.16667L4.00008 9.5L7.33341 6.16667"
        stroke="#005C29"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

